import { useQuery } from "react-query";
import getCities from "./common";
import { getFilials } from "./common";

export default function useCities(country) {
  const { data } = useQuery(["cities", country], () => getCities(country));

  return { data };
}

export function useFilias(cityId) {
  const { data, refetch } = useQuery(
      ["filials", cityId],
      () => getFilials(cityId),
      {
        enabled: !!cityId,
      }
  );
  return { data, refetch };
}
